import axios from './rest-axios';

// 获取订单列表（支持 page, size, search, md, beginDate, endDate 参数）
const getOrders = (page, size, search, md, beginDate, endDate) => {
    const params = { page, size, search, md };
    if (beginDate) params.beginDate = beginDate;
    if (endDate) params.endDate = endDate;
    return axios.get('/manage/cw_orders', params);
};

// 获取单个订单详情
const getOrderById = (id) => axios.get(`/manage/cw_orders/${id}`);

// 创建新订单
const createOrder = (order) => axios.post('/manage/cw_orders', order);

// 更新订单信息
const updateOrder = (id, order) => axios.put(`/manage/cw_orders/${id}`, order);

// 删除订单
const deleteOrder = (id) => axios.delete(`/manage/cw_orders/${id}`);

// 生成订单号
const generateOrderNo = (date) => axios.get('/manage/cw_orders/generate/order_no', { 
    date
});

export {
    getOrders,
    getOrderById,
    createOrder,
    updateOrder,
    deleteOrder,
    generateOrderNo,
};